import { render, staticRenderFns } from "./MailIcon.vue?vue&type=template&id=a416ff3e&scoped=true&"
import script from "./MailIcon.vue?vue&type=script&lang=js&"
export * from "./MailIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a416ff3e",
  null
  
)

export default component.exports